export default {
  main: "Main",
  dossier: "Dossier"
}
